<template>
  <div
    class="menu"
    :class="{
      open: Open,
    }"
  >
    <transition-group name="fade">
      <div
        key="Caracteristicas"
        v-if="Content == 'caracteristicas'"
        class="menu__caracteristicas"
      >
        <div class="menu__caracteristicas__grupos">
          <div
            v-for="(Grupo, GrupoIndex) in aplicacion.coleccionSel.sideSel
              .grupos"
            :key="GrupoIndex"
            class="menu__caracteristicas__grupos__item"
            @click="SetGrupo(Grupo)"
            :class="{
              active: Grupo.cod == aplicacion.grupoSel.cod,
            }"
          >
            <div class="menu__caracteristicas__grupos__item__grupo">
              <div class="menu__caracteristicas__grupos__item__grupo__name">
                {{ Grupo.GetLiteral(aplicacion.languageSel) }}
              </div>
              <img
                src="@/assets/Images/Global/Expand.svg"
                alt=""
                class="menu__caracteristicas__grupos__item__grupo__expand"
              />
            </div>
            <div
              class="menu__caracteristicas__grupos__item__separator"
              :class="{
                hidden:
                  GrupoIndex ==
                  aplicacion.coleccionSel.sideSel.grupos.findIndex(
                    (Element) => Element.cod == aplicacion.grupoSel.cod
                  ) -
                    1,
              }"
            ></div>
          </div>
          <div class="menu__caracteristicas__grupos__separator"></div>
        </div>
        <div class="menu__caracteristicas__campos">
          <div
            v-for="(Campo, CampoIndex) in aplicacion.grupoSel.campos"
            :key="CampoIndex"
            v-if="ResolveCondicion(Campo.condicion)"
            class="menu__caracteristicas__campos__item"
            :tipo="Campo.tipo"
          >
            <div class="menu__caracteristicas__campos__item__title">
              {{ Campo.GetLiteral(aplicacion.languageSel) }}
            </div>
            <div
              v-if="Campo.tipo == 'tacos'"
              class="menu__caracteristicas__campos__item__acabados"
            >
              <div
                v-for="(Acabado, AcabadoIndex) in Campo.acabados"
                :key="AcabadoIndex"
                v-if="ResolveCondicion(Acabado.condicion)"
                class="menu__caracteristicas__campos__item__acabados__item"
                @click="SetAcabado($event, Campo, Acabado)"
                :class="{
                  active: Campo.acabadoSel.cod == Acabado.cod,
                }"
              >
                <div
                  class="menu__caracteristicas__campos__item__acabados__item__miniatura skeleton"
                >
                  <img
                    @load="ResolveImage($event)"
                    :src="RequireImage('Tacos', Acabado.taco)"
                    alt=""
                    class="menu__caracteristicas__campos__item__acabados__item__miniatura__image"
                  />
                </div>
                <p
                  class="menu__caracteristicas__campos__item__acabados__item__name"
                >
                  {{ Acabado.GetLiteral(aplicacion.languageSel) }}
                </p>
              </div>
            </div>
            <div
              v-else-if="Campo.tipo == 'dropdown'"
              class="menu__caracteristicas__campos__item__dropdown"
            >
              <div
                class="menu__caracteristicas__campos__item__dropdown__selected"
                @click="OpenInput($event)"
              >
                <div
                  v-if="Campo.acabadoSel != undefined"
                  class="menu__caracteristicas__campos__item__dropdown__selected__value"
                >
                  {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                </div>
                <div
                  v-else
                  class="menu__caracteristicas__campos__item__dropdown__selected__value"
                >
                  POSIBLE INPUT???
                </div>
                <img
                  src="@/assets/Images/Global/Expand.svg"
                  alt=""
                  class="menu__caracteristicas__campos__item__dropdown__selected__expand"
                />
              </div>
              <div
                class="menu__caracteristicas__campos__item__dropdown__values"
              >
                <div
                  v-for="(Value, ValueIndex) in Campo.acabados"
                  :key="ValueIndex"
                  v-if="ResolveCondicion(Value.condicion)"
                  class="menu__caracteristicas__campos__item__dropdown__values__item"
                  @click="SetAcabado($event, Campo, Value)"
                  :class="{
                    active: Campo.acabadoSel.cod == Value.cod,
                  }"
                >
                  {{ Value.GetLiteral(aplicacion.languageSel) }}
                </div>
              </div>
            </div>
            <input
              v-else
              :placeholder="''"
              class="menu__caracteristicas__campos__item__input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div key="Resumen" v-else-if="Content == 'resumen'" class="menu__resumen">
        <div class="menu__resumen__top">
          <p class="menu__resumen__top__title">Resumen</p>
        </div>
        <div class="menu__resumen__grupos">
          <div
            v-for="(
              Grupo, GrupoIndex
            ) in aplicacion.coleccionSel.sideSel.grupos.filter(
              (Grupo) => Grupo.cod != 'REVESTIMIENTO'
            )"
            :key="GrupoIndex"
            class="menu__resumen__grupos__item"
          >
            <p class="menu__resumen__grupos__item__title">
              {{ Grupo.GetLiteral(aplicacion.languageSel) }}
            </p>
            <div class="menu__resumen__grupos__item__campos">
              <div
                v-for="(Campo, CampoIndex) in Grupo.campos"
                :key="CampoIndex"
                v-if="ResolveCondicion(Campo.condicion)"
                class="menu__resumen__grupos__item__campos__item"
              >
                <div class="menu__resumen__grupos__item__campos__item__title">
                  <p
                    class="menu__resumen__grupos__item__campos__item__title__campo"
                  >
                    {{ Campo.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <p
                    v-if="Campo.tipo == 'tacos'"
                    class="menu__resumen__grupos__item__campos__item__title__value"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                </div>
                <div
                  v-if="Campo.tipo == 'tacos'"
                  class="menu__resumen__grupos__item__campos__item__miniatura"
                >
                  <img
                    @load="ResolveImage($event)"
                    :src="RequireImage('Tacos', Campo.acabadoSel.taco)"
                    alt=""
                    class="menu__resumen__grupos__item__campos__item__miniatura__image"
                  />
                </div>
                <p
                  v-else-if="Campo.tipo == 'dropdown'"
                  class="menu__resumen__grupos__item__campos__item__value"
                >
                  {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                </p>
                <p
                  v-else
                  class="menu__resumen__grupos__item__campos__item__value"
                >
                  INPUT
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="menu__resumen__bottom">
          <button class="menu__resumen__bottom__buy">¿ Dónde Comprar ?</button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: {
    Open: Boolean,
    Content: String,
    aplicacion: Object,
  },
  methods: {
    ResolveImage(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      element.parentNode.classList.remove("skeleton");
      setTimeout(() => {
        element.style.opacity = 1;
      }, 50);
    },
    RequireImage(Folder, url) {
      var Image;
      try {
        Image = require("@/assets/Images/" + Folder + "/" + url);
      } catch (error) {
        Image = require("@/assets/Images/" + Folder + "/Error.webp");
      }
      return Image;
    },
    SetGrupo(Object) {
      this.$emit("Grupo", Object);
    },
    SetAcabado(e, CampoObject, AcabadoObject) {
      if (CampoObject.tipo == "dropdown") {
        var element;
        if (e.target == null || e.target == undefined) {
          element = e.path[0];
        } else {
          element = e.target;
        }
        var Input = element.parentNode.parentNode;
        var Value = Input.children[0].children[0];
        Value.style.opacity = 0;
        setTimeout(() => {
          Input.classList.remove("open");
          setTimeout(() => {
            this.$emit("Acabado", CampoObject, AcabadoObject);
            Value.style.opacity = 1;
          }, 250);
        }, 100);
      } else {
        this.$emit("Acabado", CampoObject, AcabadoObject);
      }
    },
    OpenInput(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }

      var Input = element;

      if (
        element.classList.contains(
          "menu__caracteristicas__campos__item__dropdown__selected"
        )
      ) {
        Input = element.parentNode;
      } else {
        Input = element.parentNode.parentNode;
      }
      var Campos = Input.parentNode.parentNode.children;
      for (const Campo of Campos) {
        if (Campo.getAttribute("tipo") == "dropdown") {
          if (Campo.children[1] != Input) {
            Campo.children[1].classList.remove("open");
          }
        }
      }

      Input.classList.toggle("open");
    },
    ResolveCondicion(Condicion) {
      var Status = true;

      if (Condicion != "") {
        try {
          var perfil = this.aplicacion.perfil;
          Status = eval(Condicion);
        } catch (error) {
          console.log(Condicion);
        }
      }

      return Status;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  width: 350px;
  height: 100%;
  margin-right: -350px;
  background-color: rgb(243, 244, 246);
  -webkit-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -moz-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -ms-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -o-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  transition: margin-right 0.35s ease-in-out, background-color 0.35s ease-in-out;
  &__caracteristicas {
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    width: 100%;
    height: 100%;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;
    &__grupos {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      width: 100%;
      height: auto;
      padding: 25px 25px 0px 25px;
      &__item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        width: 100%;
        &__grupo {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          align-content: center;
          width: 100%;
          color: black;
          background-color: transparent;
          padding: 8px 12px;
          border-radius: 5px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
          &__name {
            font-size: 14px;
          }
          &__expand {
            height: 22px;
            filter: invert(0%) brightness(100%);
            transform: rotate(0deg);
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }
        &__separator {
          opacity: 1;
          width: 100%;
          height: 0.01em;
          background-color: black;
          -webkit-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          -o-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          &.hidden {
            opacity: 0;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }
        &.active {
          & .menu__caracteristicas__grupos__item {
            &__grupo {
              color: white;
              background-color: black;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
              &__expand {
                filter: invert(100%) brightness(100%);
                transform: rotate(180deg);
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
            &__separator {
              opacity: 0;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }
          }
        }
        &:nth-last-child(2) {
          & .menu__caracteristicas__grupos__item {
            &__separator {
              display: none;
            }
          }
        }
      }
      &__separator {
        margin-top: 25px;
        width: 100%;
        height: 4px;
        background-color: black;
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;
      }
    }
    &__campos {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      width: 100%;
      height: 100%;
      padding: 25px;
      overflow: overlay;
      &__item {
        width: 100%;
        &__title {
          color: black;
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 15px;
          -webkit-transition: color 0.35s ease-in-out;
          -moz-transition: color 0.35s ease-in-out;
          -ms-transition: color 0.35s ease-in-out;
          -o-transition: color 0.35s ease-in-out;
          transition: color 0.35s ease-in-out;
        }
        &__acabados {
          display: grid;
          grid-auto-rows: 1fr;
          grid-template-columns: 1fr 1fr 1fr;
          grid-gap: 10px;
          &__item {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            align-content: center;
            &__miniatura {
              background-image: url("@/assets/Images/Global/Transparent.webp");
              background-repeat: no-repeat;
              background-position: center;
              background-size: 60%;
              width: 91.48px;
              height: 91.48px;
              border: 1px solid transparent;
              border-radius: 5px;
              padding: 4px;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
              &__image {
                opacity: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 2.5px;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }
            &__name {
              color: black;
              font-size: 11px;
              max-width: 65px;
              margin-top: 5px;
              padding-left: 5px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }
            &.active {
              & .menu__caracteristicas__campos__item__acabados__item {
                &__miniatura {
                  border: 1px solid black;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }
          }
        }
        &__dropdown {
          position: relative;
          &__selected {
            color: black;
            background-color: transparent;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            align-content: center;
            border: 1px solid black;
            padding: 8px 12px;
            border-radius: 5px;
            position: relative;
            z-index: 1;
            background-color: rgb(243, 244, 246);
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
            &__value {
              opacity: 1;
              font-size: 14px;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }
            &__expand {
              height: 22px;
              transform: rotate(0deg);
              -webkit-transition: filter 0.35s ease-in-out,
                transform 0.35s ease-in-out;
              -moz-transition: filter 0.35s ease-in-out,
                transform 0.35s ease-in-out;
              -ms-transition: filter 0.35s ease-in-out,
                transform 0.35s ease-in-out;
              -o-transition: filter 0.35s ease-in-out,
                transform 0.35s ease-in-out;
              transition: filter 0.35s ease-in-out, transform 0.35s ease-in-out;
            }
          }

          &__values {
            opacity: 0;
            pointer-events: none;
            position: absolute;
            top: 10px;
            left: 0px;
            width: 100%;
            background-color: rgb(245, 245, 245);
            border: 1px solid black;
            border-radius: 0px 0px 5px 5px;
            -webkit-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
              color 0.35s ease-in-out, border 0.35s ease-in-out,
              background-color 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
              color 0.35s ease-in-out, border 0.35s ease-in-out,
              background-color 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
              color 0.35s ease-in-out, border 0.35s ease-in-out,
              background-color 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
              color 0.35s ease-in-out, border 0.35s ease-in-out,
              background-color 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
              color 0.35s ease-in-out, border 0.35s ease-in-out,
              background-color 0.35s ease-in-out;
            &__item {
              cursor: pointer;
              color: black;
              padding: 0px 0px;
              font-size: 0px;
              background-color: transparent;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
              &:hover {
                background-color: rgb(220, 220, 220);
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
              &:last-child {
                border-radius: 0px 0px 5px 5px;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
              &.active {
                color: white;
                background-color: rgb(76, 136, 183);
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
          }
          &.open {
            & .menu__caracteristicas__campos__item__dropdown {
              &__selected {
                border-radius: 5px 5px 0px 0px;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
                &__expand {
                  transform: rotate(180deg);
                  -webkit-transition: filter 0.35s ease-in-out,
                    transform 0.35s ease-in-out;
                  -moz-transition: filter 0.35s ease-in-out,
                    transform 0.35s ease-in-out;
                  -ms-transition: filter 0.35s ease-in-out,
                    transform 0.35s ease-in-out;
                  -o-transition: filter 0.35s ease-in-out,
                    transform 0.35s ease-in-out;
                  transition: filter 0.35s ease-in-out,
                    transform 0.35s ease-in-out;
                }
              }
              &__values {
                opacity: 1;
                pointer-events: visible;
                top: 38.9px;
                -webkit-transition: opacity 0.35s ease-in-out,
                  top 0.35s ease-in-out, color 0.35s ease-in-out,
                  border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  top 0.35s ease-in-out, color 0.35s ease-in-out,
                  border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                  color 0.35s ease-in-out, border 0.35s ease-in-out,
                  background-color 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                  color 0.35s ease-in-out, border 0.35s ease-in-out,
                  background-color 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                  color 0.35s ease-in-out, border 0.35s ease-in-out,
                  background-color 0.35s ease-in-out;
                &__item {
                  font-size: 14px;
                  padding: 7px 12px;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }
          }
        }
        &__input {
          color: black;
          background-color: transparent;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          align-content: center;
          border: 1px solid black;
          padding: 8px 12px;
          border-radius: 5px;
          position: relative;
          z-index: 1;
          width: 100%;
          height: 40px;
          outline: none;
          font-size: 14px;
          background-color: rgb(243, 244, 246);
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
          &::placeholder {
            color: rgb(150, 150, 150);
            opacity: 1;
          }

          &:-ms-input-placeholder {
            color: rgb(150, 150, 150);
          }

          &::-ms-input-placeholder {
            color: rgb(150, 150, 150);
          }
        }
        &:not(:first-child) {
          margin-top: 35px;
        }
      }
    }
  }
  &__resumen {
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    width: 100%;
    height: 100%;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;
    &__top {
      width: 100%;
      height: auto;
      padding: 25px 25px 0px 25px;
      &__title {
        color: black;
        font-size: 20px;
        border-bottom: 1px solid black;
        padding-bottom: 7px;
        -webkit-transition: border-bottom 0.35s ease-in-out,
          color 0.35s ease-in-out;
        -moz-transition: border-bottom 0.35s ease-in-out,
          color 0.35s ease-in-out;
        -ms-transition: border-bottom 0.35s ease-in-out, color 0.35s ease-in-out;
        -o-transition: border-bottom 0.35s ease-in-out, color 0.35s ease-in-out;
        transition: border-bottom 0.35s ease-in-out, color 0.35s ease-in-out;
      }
    }
    &__grupos {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      width: 100%;
      height: 100%;
      overflow: overlay;
      padding: 0px 25px 0px 25px;
      &__item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: center;
        width: 100%;
        border-bottom: 1px solid black;
        padding: 15px 0px;
        -webkit-transition: border-bottom 0.35s ease-in-out;
        -moz-transition: border-bottom 0.35s ease-in-out;
        -ms-transition: border-bottom 0.35s ease-in-out;
        -o-transition: border-bottom 0.35s ease-in-out;
        transition: border-bottom 0.35s ease-in-out;
        &__title {
          color: black;
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 10px;
          -webkit-transition: color 0.35s ease-in-out;
          -moz-transition: color 0.35s ease-in-out;
          -ms-transition: color 0.35s ease-in-out;
          -o-transition: color 0.35s ease-in-out;
          transition: color 0.35s ease-in-out;
        }
        &__campos {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          align-content: center;
          width: 100%;
          &__item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            align-content: center;
            width: 100%;
            &:not(:first-child) {
              margin-top: 20px;
            }
            &__title {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              align-content: center;
              &__campo {
                color: black;
                font-size: 15px;
                white-space: nowrap;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }
              &__value {
                color: black;
                white-space: nowrap;
                font-size: 13px;
                font-weight: 600;
                margin-top: 3px;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }
            }
            &__miniatura {
              background-image: url("@/assets/Images/Global/Transparent.webp");
              background-repeat: no-repeat;
              background-position: center;
              background-size: 60%;
              width: 75px;
              height: 75px;
              border: 1px solid transparent;
              border-radius: 5px;
              padding: 4px;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
              &__image {
                opacity: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 2.5px;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }
            &__value {
              color: black;
              white-space: nowrap;
              font-size: 13px;
              font-weight: 600;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }
          }
        }
      }
    }
    &__bottom {
      width: 100%;
      padding: 25px;
      &__buy {
        cursor: pointer;
        width: 100%;
        height: 40px;
        outline: none;
        border: none;
        color: white;
        background-color: black;
        border-radius: 5px;
        padding: 8px 12px;
      }
    }
  }
  &.open {
    margin-right: 0px;
    -webkit-transition: margin-right 0.35s ease-in-out;
    -moz-transition: margin-right 0.35s ease-in-out;
    -ms-transition: margin-right 0.35s ease-in-out;
    -o-transition: margin-right 0.35s ease-in-out;
    transition: margin-right 0.35s ease-in-out;
  }
}
</style>
